export function truncateText(
  text: string | null | undefined,
  maxLength: number = 100
): string {
  if (!text) return "";

  if (text.length <= maxLength) {
    return text;
  }

  return text.substring(0, maxLength).trim() + "...";
}

export function truncateTextByWords(
  text: string | null | undefined,
  maxLength: number = 100
): string {
  if (!text) return "";

  if (text.length <= maxLength) {
    return text;
  }

  let truncated = text.substring(0, maxLength);

  const lastSpace = truncated.lastIndexOf(" ");
  if (lastSpace > maxLength * 0.7) {
    truncated = truncated.substring(0, lastSpace);
  }

  return truncated.trim() + "...";
}
